<template lang="pug">
  .container.relative(v-on-clickaway='hideOptions')
    button.icon-button(
      v-if='editPermission'
      type='button'
      @click='toggleOptions'
      :class='{ active: showOptions }'
    )
      simple-svg.blue-hover-dark-gray(:filepath='dotsIcon' :width='iconSize' :height='iconSize')
    transition(name='modal')
      .options-container.column(v-if='showOptions')
        //- TODO: Implement manage options action action
        button.row.option.middle(type='button' @click='managePermissions')
          simple-svg.gray-icon.m4-right-2(:filepath='peopleIcon' width='20px' height='20px')
          span.text-small
            | {{ $t('folders.managePermissions') }}
        button.row.option.middle(type='button' @click='handleDelete')
          simple-svg.gray-icon.m4-right-2(:filepath='trashIcon' width='20px' height='20px')
          span.text-small
            | {{ $t('folders.delete') }}
    folder-manage-permissions-modal(v-if='showManagePermissionsModal')
    folder-delete-modal(v-if='showDeleteModal')
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'

import FolderDeleteModal from '@/components/Folders/FolderDeleteModal'
import FolderManagePermissionsModal from '@/components/Folders/FolderManagePermissionsModal'

import pencilIcon from '@/assets/ic_pencil.svg'
import peopleIcon from '@/assets/ic_user_two.svg'
import trashIcon from '@/assets/ic_trash.svg'
import dotsIcon from '@/assets/ic_more_dots.svg'

export default {
  props: {
    editPermission: { type: Boolean },
    folderId: { type: Number, required: true },
    folderName: { type: String, required: true },
    smallIcon: { type: Boolean, required: false }
  },
  mixins: [ clickaway ],
  components: {
    FolderDeleteModal,
    FolderManagePermissionsModal
  },
  data() {
    return {
      showOptions: false,
      pencilIcon,
      trashIcon,
      peopleIcon,
      dotsIcon
    }
  },
  computed: {
    ...mapState({
      managePermissionsModalOptions: state => state.behavior.folderManagePermissionsModal,
      deleteModalOptions: state => state.behavior.folderDeleteModal
    }),
    iconSize() {
      return this.smallIcon ? '15px' : '20px'
    },
    showManagePermissionsModal() {
      const modalOptions = this.managePermissionsModalOptions
      return modalOptions.show && modalOptions.props.folderId === this.folderId
    },
    showDeleteModal() {
      const modalOptions = this.deleteModalOptions
      return modalOptions.show && modalOptions.props.folderId === this.folderId
    }
  },
  methods: {
    ...mapActions(['getFolderDetails', 'showElement']),
    toggleOptions() {
      this.showOptions = !this.showOptions
    },
    handleDelete() {
      this.hideOptions()
      this.showElement({ element: 'folderDeleteModal', props: { folderId: this.folderId } })
    },
    managePermissions() {
      this.hideOptions()
      this.showElement({ element: 'folderManagePermissionsModal', props: { folderId: this.folderId } })
    },
    hideOptions() {
      this.showOptions = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.options-container {
  border: 1px solid $light-gray;
  border-radius: 5px;
  box-shadow: 0 3px 10px 0 $shadow-blacker;
  width: 212px;
  right: -10px;
  position: absolute;
  top: 30px;

  &::before {
    background: url('../../assets/ic_triangle.svg') no-repeat;
    content: '';
    height: 9px;
    position: absolute;
    right: 20px;
    top: -5px;
    width: 22px;
  }

  .option {
    align-items: flex-end;
    background: $white;
    padding: 10px 12px;
    z-index: 1;

    &:first-child {
      border-radius: 4px 4px 0 0;
    }

    &:last-child {
      border-radius: 0 0 4px 4px;
    }

    &:not(:last-child) {
      border-bottom: 1px solid $light-gray;
    }

    &:hover,
    &:focus {
      background: $light-gray;
    }
  }
}
</style>
